<template>
  <section :class="['about-summary', { 'about-summary-blue': isBgBlue }]">
    <div class="about-summary-inner">
      <img src="@/assets/img/img_about.png" alt="" class="about-image" />
      <div class="about-copy">
        <p class="eyebrow">{{ $t('about.Title') }}</p>
        <h2>{{ $t('about.Heading') }}</h2>
        <p class="lead">{{ $t('about.Intro') }}</p>
        <p>{{ $t('about.Service') }}</p>
        <p>{{ $t('about.Team') }}</p>
        <p>{{ $t('about.Commitment') }}</p>
        <router-link v-if="isBgBlue" :to="$siteLink('/about')" class="about-link">{{ $t('about.LearnMore') }} <span aria-hidden="true">→</span></router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isBgBlue: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.about-summary { background: #fff; color: #163257; }
.about-summary-blue { background: #163257; color: #fff; }
.about-summary-inner { max-width: 1440px; margin: 0 auto; padding: clamp(36px, 7vw, 100px); display: grid; grid-template-columns: 1fr 1fr; gap: clamp(32px, 5vw, 72px); align-items: center; }
.about-image { display: block; width: 100%; height: auto; }
.about-copy { min-width: 0; }
.eyebrow { color: #bc9a41; font-size: 18px; font-weight: 600; }
.about-summary:not(.about-summary-blue) .eyebrow { color: #8a6e29; }
h2 { margin: 12px 0 24px; font-size: clamp(26px, 2.8vw, 38px); line-height: 1.3; font-weight: 600; color: inherit; }
p { margin: 0 0 16px; font-size: 16px; line-height: 1.8; }
.lead { font-size: 19px; line-height: 1.75; margin-bottom: 20px; }
.about-link { display: inline-block; color: inherit; font-weight: 600; text-decoration: underline; text-underline-offset: 5px; line-height: 1.7; }
.about-link span { margin-left: 8px; }
@media (max-width: 768px) {
  .about-summary-inner { grid-template-columns: 1fr; padding: 36px 6vw; gap: 28px; }
  .lead { font-size: 17px; }
}
</style>
